// Predefined skills for AI employees
export interface SkillCategory {
  category: string;
  skills: string[];
}

export const skillCategories: SkillCategory[] = [
  {
    category: 'Development',
    skills: [
      'JavaScript',
      'TypeScript',
      'React',
      'Angular',
      'Vue.js',
      'Node.js',
      'Python',
      'Java',
      'C#',
      'PHP',
      'Ruby',
      'Swift',
      'Kotlin',
      'Go',
      'Rust',
      'Mobile Development',
      'Web Development',
      'API Development',
      'Database Design',
      'DevOps',
      'Cloud Architecture',
      'Microservices',
      'Serverless',
      'Docker',
      'Kubernetes'
    ]
  },
  {
    category: 'Data & Analytics',
    skills: [
      'Data Analysis',
      'Data Visualization',
      'Business Intelligence',
      'SQL',
      'NoSQL',
      'Big Data',
      'Data Warehousing',
      'ETL',
      'Machine Learning',
      'Deep Learning',
      'Natural Language Processing',
      'Computer Vision',
      'Predictive Analytics',
      'Statistical Analysis',
      'R Programming',
      'Python for Data Science',
      'TensorFlow',
      'PyTorch',
      'Power BI',
      'Tableau'
    ]
  },
  {
    category: 'Design',
    skills: [
      'UI/UX Design',
      'Graphic Design',
      'Web Design',
      'Mobile Design',
      'Prototyping',
      'User Research',
      'Wireframing',
      'Adobe Creative Suite',
      'Figma',
      'Sketch',
      'InVision',
      'Accessibility',
      'Motion Design',
      'Illustration',
      'Typography',
      'Brand Identity',
      'Design Systems',
      'Responsive Design',
      'Interaction Design',
      'Visual Design'
    ]
  },
  {
    category: 'Project Management',
    skills: [
      'Project Management',
      'Agile',
      'Scrum',
      'Kanban',
      'Waterfall',
      'JIRA',
      'Confluence',
      'Trello',
      'Asana',
      'Monday.com',
      'Risk Management',
      'Budgeting',
      'Resource Allocation',
      'Stakeholder Management',
      'Project Planning',
      'Project Scheduling',
      'Project Tracking',
      'Project Reporting',
      'Team Leadership',
      'Process Improvement'
    ]
  },
  {
    category: 'Marketing',
    skills: [
      'Digital Marketing',
      'Social Media Marketing',
      'Content Marketing',
      'Email Marketing',
      'SEO',
      'SEM',
      'PPC',
      'Google Analytics',
      'Google Ads',
      'Facebook Ads',
      'Instagram Marketing',
      'LinkedIn Marketing',
      'Twitter Marketing',
      'TikTok Marketing',
      'Influencer Marketing',
      'Affiliate Marketing',
      'Marketing Automation',
      'Marketing Strategy',
      'Brand Management',
      'Market Research'
    ]
  },
  {
    category: 'HR & Recruitment',
    skills: [
      'Recruitment',
      'Talent Acquisition',
      'Employee Relations',
      'Performance Management',
      'HR Policies',
      'Compensation & Benefits',
      'Training & Development',
      'Onboarding',
      'Offboarding',
      'Employee Engagement',
      'Diversity & Inclusion',
      'HR Analytics',
      'HRIS',
      'Workforce Planning',
      'Succession Planning',
      'Labor Relations',
      'Compliance',
      'Payroll',
      'Benefits Administration',
      'Employee Wellness'
    ]
  },
  {
    category: 'Writing & Communication',
    skills: [
      'Technical Writing',
      'Copywriting',
      'Content Creation',
      'Proposal Writing',
      'Bid Management',
      'Grant Writing',
      'Editing',
      'Proofreading',
      'Research',
      'Blogging',
      'Storytelling',
      'Scriptwriting',
      'Speechwriting',
      'Business Writing',
      'Academic Writing',
      'Creative Writing',
      'SEO Writing',
      'Email Communication',
      'Report Writing',
      'Documentation'
    ]
  },
  {
    category: 'Administrative',
    skills: [
      'Administrative Support',
      'Calendar Management',
      'Email Management',
      'Data Entry',
      'Document Management',
      'Travel Arrangements',
      'Meeting Coordination',
      'Office Management',
      'Virtual Assistance',
      'Executive Support',
      'Customer Service',
      'CRM Management',
      'Bookkeeping',
      'Invoicing',
      'Expense Reporting',
      'Inventory Management',
      'Filing',
      'Transcription',
      'Note Taking',
      'Scheduling'
    ]
  }
];

// All skills flattened into a single array
export const allSkills: string[] = skillCategories.flatMap(category => category.skills);
